import React, { useState } from 'react';
import axios from 'axios';
import './register.css';
import { useHistory } from 'react-router-dom';
import './register.css'
import PicLogin from '../../images/cleanWorld.jpg'


const Register = () => {

    const [user, setUser] = useState({
        firstname: '',
        lastname: '',
        phone: '',
        mail: '',
        password: '',

    })

    let history = useHistory()
    const [confirmePassword, setConfirmePassword] = useState('')
    const [errorPassword, setErrorPassword] = useState(null)


    const queryData = (e) => {
        e.preventDefault()

        if (user.password === confirmePassword && user.password.length >= 6) {
            axios.post('https://clean-my-calanques.herokuapp.com/LoginRoute/register', user)

                .then(res => {
                    history.push('/Login')
                })
        }
        else {
            setErrorPassword('Le mot de passe ou le mail ne correspondent pas, veuillez reessayer')
        }
    }

    return (
        <div className="containerRegister">

            <img className="picLogin" src={PicLogin} alt="picLogin"></img>
            <div className="contain2">
                <h1 className="titleRegister">Rejoignez la communauté !</h1>
                <form onSubmit={queryData}>
                    <div className="names">
                        <input className="prenom" placeholder="Prénom" name='firstname' value={user.firstname} required type='text' onChange={(e) => setUser({ ...user, firstname: e.target.value })} />
                        <input placeholder="Nom" name='lastname' value={user.lastname} required type='text' onChange={(e) => setUser({ ...user, lastname: e.target.value })} />
                    </div>
                    <input className="at" placeholder="E-mail" name='mail' value={user.mail} required type='text' onChange={(e) => setUser({ ...user, mail: e.target.value })} />
                    <input className="phone" placeholder="Téléphone" name='phone' value={user.phone} required type='text' onChange={(e) => setUser({ ...user, phone: e.target.value })} />
                    <input className="lock" placeholder="Choisis ton Mot de passe" name='password' value={user.password} required type='password' onChange={(e) => setUser({ ...user, password: e.target.value })} />
                    <p>{errorPassword}</p>
                    <input className="lock" placeholder="Confirme ton Mot de Passe" name='confirmepassword' value={confirmePassword} minLength='6' required type='password' onChange={(e) => setConfirmePassword(e.target.value)} />


                    <button className='btnRegister' type='submit'>
                        S'enregistrer !
            </button>

                </form>
            </div>
        </div>
    );
}

export default Register;